<mat-dialog-content class="dialog-text-area">
  <div layout="row" class="btn-close">
    <button
      [mat-dialog-close]="false"
      mat-icon-button
      aria-label="Close"
      layout="row"
      layout-align="end"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <img class="dialog-image" [src]="dialogInfo.imageUrl" />
  <h2 class="dialog-main-text">{{ dialogInfo.primaryText }}</h2>
  <P class="dialog-secondary-text"> {{ dialogInfo.secondaryText }} </P>
</mat-dialog-content>
<mat-dialog-actions class="dialog-btn-area" align="center">
  <button class="btn-clear" mat-raised-button [mat-dialog-close]="false">
    {{ dialogInfo.btnCancelText }}
  </button>
  <button
    class="btn-salvar"
    mat-raised-button
    [mat-dialog-close]="true"
    (click)="confirm()"
  >
    {{ dialogInfo.btnConfirmText }}
  </button>
</mat-dialog-actions>
